import { FC } from 'react'
import { Box, Typography } from '@mui/material'
import { keyframes } from '@mui/material/styles'

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
`

const R = '16px'

interface KpiCardProps {
  label: string
  value: string
  accent: string
  subtitle?: string
  delay: number
}

export const KpiCard: FC<KpiCardProps> = ({ label, value, accent, subtitle, delay }) => (
  <Box
    sx={{
      'background': '#fff',
      'borderRadius': R,
      'border': '1px solid rgba(0,0,0,0.06)',
      'p': 2.5,
      'animation': `${fadeIn} 0.5s ease-out ${delay}ms both`,
      'transition': 'transform 0.2s ease',
      '&:hover': { transform: 'translateY(-1px)' },
      'flex': 1,
      'minWidth': 180,
    }}
  >
    <Typography
      sx={{
        fontSize: 11,
        fontWeight: 600,
        color: 'rgba(0,0,0,0.3)',
        textTransform: 'uppercase',
        letterSpacing: '0.08em',
        mb: 1,
      }}
    >
      {label}
    </Typography>
    <Typography
      sx={{
        fontSize: 28,
        fontWeight: 700,
        color: accent,
        fontVariantNumeric: 'tabular-nums',
        lineHeight: 1.1,
      }}
    >
      {value}
    </Typography>
    {subtitle && (
      <Typography sx={{ fontSize: 12, color: 'rgba(0,0,0,0.4)', mt: 0.5 }}>
        {subtitle}
      </Typography>
    )}
  </Box>
)
